import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconSubscriptionClock: React.FC<IconProps> = ({ width = 16, height = 16 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_85288)">
                <circle cx="7.9987" cy="7.9987" r="6.66667" stroke="#7F7F7F" stroke-width="1.5" />
                <path
                    d="M8 5.33203V7.9987L9.66667 9.66536"
                    stroke="#7F7F7F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_85288">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSubscriptionClock;
